import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "var(--color-black)",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5.528 5.529c.26-.26.683-.26.943 0l4 4a.667.667 0 0 1-.943.942l-4-4a.667.667 0 0 1 0-.942",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.471 5.529c.26.26.26.682 0 .942l-4 4a.667.667 0 1 1-.943-.942l4-4c.26-.26.683-.26.943 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }